import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import type { RootState } from '../../types/store';
import Standard from './standard/standard';
import Speaker from './speaker/speaker';
import HeaderWithBackNav from '../../components/ui-header-back';
import { Box, Container, Stack, Alert, useMediaQuery, useTheme } from '@mui/material';
import AppConstants from '../../constants/app-constants';

export default function Create() {
    const theme = useTheme();
    const desktopView = useMediaQuery(theme.breakpoints.up("sm"));
    const translate = useSelector((state:RootState) => state.ui.language.create);
    const { mode } = useParams();
    
    switch(parseInt(mode ? mode : "0"))
    {
        case AppConstants.GAMEMODE_STANDARD:
            return(<Standard />);
        case AppConstants.GAMEMODE_SPEAKER:
            return(<Speaker />);
        default:
            return(
                <Box display={"flex"} justifyContent={"center"} alignItems={"center"} width={"100%"} minHeight={"100dvh"}>
                    <Container maxWidth="xl">
                        <center>
                            <Box bgcolor={desktopView ? theme.palette.secondary.main : ""} borderRadius={1} padding={2} width={desktopView ? "60%" : "100%"}>
                                <HeaderWithBackNav text={translate.createError} size={"md"} target="/create" />
                                <Stack gap={2}>
                                    <Alert severity="error">{translate.invalidGameMode}</Alert>
                                </Stack>
                            </Box>
                        </center>
                    </Container>
                </Box>
            );
    }
};
